import { canEditPermission } from "configs/constants";
import { withPermission } from "hocs/withPermission";
import React from "react";
import { useSelector } from "react-redux";
import withFetchOne from "../../../../hocs/withFetchOne";
import ClientForm from "../components/form/ClientForm";
import AdminClientHeader from "../components/header/AdminClientHeader";
import { doGetUser } from "../store/thunks";
import { selectUser } from "../store/userSlice";
import "./AdminUserCreateClient.scss";

const AdminEditUserClient = () => {
  const breadCrumbs = [
    { text: "USERS" },
    { url: "/admin/users/clients", text: "CLIENTS" },
    { text: "EDIT" }
  ];
  const userClient = useSelector(selectUser);
  return (
    <div className="AdminEditUserClient admin-create-update-client">
      <AdminClientHeader breadCrumbs={breadCrumbs} hasButton={false} />
      <div className="admin-content form-content">
        <h2 className="title">Edit Client User</h2>
        <ClientForm clientUser={userClient} />
      </div>
    </div>
  );
};
export default withPermission(
  withFetchOne(AdminEditUserClient, {
    fetchData: doGetUser
  }),
  canEditPermission
);
